import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ExportDataFunctionalitiesColumnsDisplaySettingsContainer } from './exportDataFunctionalitiesColumnsDisplaySettings.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportDataFunctionalitiesColumnsDisplaySettings: undefined;
  }
}
modalRenderer.register('ExportDataFunctionalitiesColumnsDisplaySettings', ExportDataFunctionalitiesColumnsDisplaySettingsContainer);
